// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1diG3","choiceBoxes":"toolbarselects_choiceBoxes__Fmzd5","simpleField":"toolbarselects_simpleField__6Om85"};